<template>
    <b-card title="E Kiosk Dashboard">
      

      <!-- End of Modal Needed on this page-->
      <b-col cols="12">
        <b-row>
          <b-col style="margin: 15px 0 0 0" cols="12">
            <b-table
              class="custom-row-height"
              show-empty
              :items="data"
              :fields="fields"
              thead-class="compact-header"
              tbody-class="compact-body"
              responsive
            >
              <template #cell(itemModel)="row">
                <span :style="row.item.noStock ? 'background: #ffcccc; color: #a00; padding: 2px 6px; border-radius: 3px;' : ''">
                  {{ row.item.itemModel }}
                </span>
              </template>
            </b-table>
             
          </b-col>
        </b-row>
      </b-col>
    </b-card>
  </template>
  
  <script>
  import { mapGetters, mapActions } from 'vuex';
  import { dateFormat} from '@/utils/utils'
  
  export default {
    data() {
      return {
        modalDelete: false,
        selectPO:'',
        sapStatus: 'undefined',
        statusOptions: [
          { value: 'undefined', text: 'All' },
          { value: 'A', text: 'Ready' },
          { value: 'B', text: 'Partially processed' },
          { value: 'C', text: 'Completely processed' },
          { value: 'D', text: 'Canceled' },
          { value: 'DRAFT', text: 'Draft' },
          { value: 'PO Fail', text: 'Admin Review' }
        ],
        modalTitle: "",
        modalConfirmation: false,
        messageModal : "",
        refreshInterval: null

      }
    },
    mounted() {
      this.fetchDashboardData();
      
      this.refreshInterval = setInterval(() => {
        this.fetchDashboardData();
      }, 10000);
    },
    beforeDestroy() {
      if (this.refreshInterval) {
        clearInterval(this.refreshInterval);
      }
    },
    beforeRouteLeave(to, from, next) {
      if (this.refreshInterval) {
        clearInterval(this.refreshInterval);
      }
      next();
    },
    computed: {
      ...mapGetters({
        purchase: 'purchase/purchase',
        fields: 'purchase/ekioskDashboardField',
        data: 'purchase/ekioskDashboardData'
      }),
    },
    methods: {
      ...mapActions({
        dashboardData: 'purchase/fetchKioskDashboard'
      }),
      dates(date) {
        //console.info(date);
        return dateFormat(date);
      },
      fetchDashboardData() {
        this.dashboardData()
      },
      
    },
    created() {
      document.title = 'Kiosk Dashboard | RSP';
    },
  }
  </script>
  <style lang="scss">
    .custom-row-height {
      min-height: 120px; /* Adjust this value as needed */
    }
    .compact-header {
      th {
        padding: 0.4rem 0.3rem !important;
        font-size: 0.7rem !important; /* Added !important */
      }
    }
    
    /* Increase specificity by targeting the table element */
    .b-table.table thead.compact-header th {
      font-size: 0.7rem !important;
      padding: 0.4rem 0.3rem !important;
    }
    
    .compact-body {
      td {
        padding: 0.3rem !important;
        font-size: 0.9rem;
      }
    }

    .dropdown-show{
      overflow-y: auto;
      height: 100px;
    }
  </style>
  